<div class="success-wrapper">
  <div class="success animated zoomIn" (clickOutside)="close.emit()" [clickOutsideEvents]="'click'" appClickOutsideFix >
    <div class="success-header">
      <h3>{{ title }}</h3>
      <div (click)="close.emit()" class="close"></div>
    </div>
    <div class="success-body">
      <div class="success-info">
        <p>
          {{sucessMsg}}
        </p>
        <!-- Optional advisory about the write that just succeeded (HUBX-8429's
             category notice is the first). Absent for every caller that passes none. -->
        <p class="success-note" *ngIf="note">
          {{note}}
        </p>
      </div>
      <div class="success-ctrl">
        <a role="button" class="btn" (click)="close.emit()">
          Continue
        </a>
      </div>

    </div>
  </div>
</div>
